import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogConfig,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Store } from '@ngrx/store';
import { LazyDialogLoader } from '@qtek/libs/dialog-loader';
import { AppState, SchemaEditorActions } from '@qtek/libs/store';

export const dealTypeSelectionDialogConfig: MatDialogConfig = {
  panelClass: ['qt-dialog', 'deal-type-selection-dialog'],
  width: '600px',
  maxWidth: '95vw',
};

@Component({
  selector: 'qt-deal-type-selection-dialog',
  templateUrl: './deal-type-selection-dialog.component.html',
  styleUrls: ['./deal-type-selection-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, MatDialogModule],
})
export class DealTypeSelectionDialogComponent {
  private store = inject<Store<AppState>>(Store);
  private dialogRef = inject(MatDialogRef<DealTypeSelectionDialogComponent>);
  private dialogLoader = inject(LazyDialogLoader);

  selected = signal<'current' | 'closed' | null>(null);

  selectCurrentDeal(): void {
    this.selected.set('current');
    this.dialogRef.close();
    this.store.dispatch(
      SchemaEditorActions.getSchema({ sid: 'io.synply.v1.type.product' })
    );
    this.store.dispatch(
      SchemaEditorActions.getSchema({ sid: 'io.synply.v1.type.indu' })
    );
    this.dialogLoader.open('current-deal-entry-method').subscribe();
  }

  selectClosedDeal(): void {
    this.selected.set('closed');
    this.dialogRef.close();
    this.dialogLoader.open('closed-deal-entry-method').subscribe();
  }
}
